import Vue from 'vue'
import grid from './grid/index.vue'
import select from './select.vue'

Vue.component('app-estado-grid', grid)
Vue.component('app-estado-select', select)
